// components/FeatureHighlights.jsx
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Import Swiper styles (you can override with Tailwind)

// Import your images (adjust paths to match your assets folder)
import journal from '../assets/screenshots/journal.png'
import pointofsale from '../assets/screenshots/pointofsale.png'
import invoice from '../assets/screenshots/invoice.png'
import sourcedocument from '../assets/screenshots/sourcedocument.png'
import customerledger from '../assets/screenshots/customerledger.png'
import inventory from '../assets/screenshots/inventory.png'

const slides = [journal, pointofsale, sourcedocument, invoice, customerledger, inventory];

export default function FeatureHighlights() {
    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
                        Everything You Need to Run Your Finances Smarter
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        From effortless VAT filing to real-time cash flow insights.
                    </p>
                </div>

                {/* SLIDESHOW SECTION */}
                <div className="flex flex-col md:flex-row gap-8 items-center justify-center mb-20">

                    {/* Desktop Slideshow (takes roughly 60% of row on large screens) */}
                    <div className="w-full md:w-[60%] lg:w-[50%]">
                        <Swiper
                            modules={[Navigation, Pagination, Autoplay]}
                            spaceBetween={20}
                            slidesPerView={1}
                            navigation
                            pagination={{ clickable: true }}
                            autoplay={{ delay: 3000 }}
                            className="rounded-xl shadow-2xl overflow-hidden border border-gray-200"
                        >
                            {slides.map((src, index) => (
                                <SwiperSlide key={index}>
                                    <img src={src} alt="Desktop View" className="w-full h-auto object-cover" />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>

                    {/* iPad Slideshow (Your 2560x1600 crop) */}
                    {/* We limit this to w-[25%] to match your request */}
                    {/* <div className="w-full md:w-[30%] lg:w-[25%]"> */}
                    <div className="w-full md:w-[25%] p-2 rounded-[2.5rem] shadow-2xl">
                        <Swiper
                            modules={[Pagination, Autoplay]}
                            spaceBetween={10}
                            slidesPerView={1}
                            pagination={{ clickable: true }}
                            autoplay={{ delay: 3500 }}
                            className="rounded-[2rem] shadow-xl overflow-hidden border-8 bg-black"
                        >
                            {slides.map((src, index) => (
                                <SwiperSlide key={index}>
                                    <img src={src} alt="iPad View" className="w-full h-auto" />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        {/* <p className="text-center text-sm text-gray-400 mt-4 font-medium italic">iPad Interface</p> */}
                    </div>
                </div>

                {/* FEATURES GRID */}
                <div className="grid md:grid-cols-3 gap-10">
                    {/* ... (Your existing feature items) */}
                    <FeatureItem icon="📄" title="Invoicing" desc="Create branded invoices instantly." />
                    <FeatureItem icon="📊" title="VAT Tracking" desc="Auto-track deductions easily." />
                    <FeatureItem icon="🚀" title="Data Capture" desc="Turn receipts into records." />
                </div>
            </div>
        </section>
    );
}

// Small helper component to keep code clean
function FeatureItem({ icon, title, desc }) {
    return (
        <div className="text-center">
            <div className="bg-indigo-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">{icon}</span>
            </div>
            <h3 className="text-xl font-semibold mb-2">{title}</h3>
            <p className="text-gray-600">{desc}</p>
        </div>
    );
}